import { useTranslation } from "react-i18next";
import React, {FunctionComponent, useEffect, useState} from "react";
import {Button, Col, DatePicker, Form, Row, Typography} from "antd";
import FormItemDropdown from "../../../form-dropdown/FormItemDropdown";
import {DeleteOutlined, FilterOutlined} from "@ant-design/icons";
import "./filter-group.scss";
import {FormInstance} from "antd/lib";
// import { dataStatus } from '../../../pages/list-user/constants/data';
import {FilterData} from "./filter";
import {getLecturerAssign} from "../../../../service/assign-course-construction";
import {
  getAllSectionByCourseId,
  getAllSequenceByCourseId
} from "../../../../service/content-list-course/contentListCourseApi";
import {useParams} from "react-router-dom";

type FormFilterProps = {
  handleCloseFilter: () => void;
  showFilter?: boolean;
  form: FormInstance;
  clearFilter: () => void;
  onFinish?: (value:any) => void;
  setFilterData: (dateString: string[], planCreationDate: string) => void;
  dataOptions?: any;
  tab: string;
  filterData: FilterData;
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  handleCloseFilter,
  onFinish,
  form,
  showFilter,
  clearFilter,
  dataOptions,
  filterData,
  setFilterData,
  tab,
}) => {
  const { t } = useTranslation();

  const statusList = [
    {
      value: "0",
      name: t("Bản nháp", "Bản nháp"),
      describe: t("Phần này sẽ không được người dùng nhìn thấy.", "Phần này sẽ không được người dùng nhìn thấy."),
    },
    {
      value: "1",
      name: t("Riêng tư", "Riêng tư"),
      describe: t(
        "Phần này sẽ được người dùng nhìn thấy nhưng các hoạt động học tập sẽ không thể truy cập được",
        "Phần này sẽ được người dùng nhìn thấy nhưng các hoạt động học tập sẽ không thể truy cập được"
      ),
    },
    {
      value: "2",
      name: t("Công khai", "Công khai"),
      describe: t("phần này sẽ được người dùng nhìn thấy và truy cập miễn phí.", "phần này sẽ được người dùng nhìn thấy và truy cập miễn phí."),
    },
  ];

  const statusListQuiz = [
    {
      value: true,
      name: t("Hoạt động", "Hoạt động"),
    },
    {
      value: false,
      name: t("Không hoạt động", "Không hoạt động"),
    },
  ];

  const optionShow = [
    {
      value: true,
      label: t("Hiển thị", "Hiển thị"),
    },
    {
      value: false,
      label: t("Ẩn", "Ẩn"),
    },
  ];

  const params = useParams()
  const {RangePicker} = DatePicker;
  const [dataOptionsFilter, setDataOptionsFilter] = useState<any>([]);
  const [sectionList, setSectionList] = useState<any>([])
  const [sequenceList, setSequenceList] = useState<any>([])

  const getListLecturerFilter = async () => {
    await getLecturerAssign().then((res) => {
      setDataOptionsFilter(res.data.data);
    });
  };

  const getAllSection = async () => {
    await getAllSectionByCourseId(params?.id).then((res) => {
      setSectionList(res.data)
    })
  }

  const getAllSequence = async () => {
    await getAllSequenceByCourseId(params?.id).then((res) => {
      setSequenceList(res.data)
    })
  }

  useEffect(() => {
    getAllSection()
    getAllSequence()
    getListLecturerFilter();
  }, [tab]);

  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form form={form} name="filterForm" onFinish={onFinish}>
          <Row gutter={[{xs: 8, xl: 24, md: 16}, 12]}>
            {
              tab === '2' || tab === '3' ?
                <> {tab === '2' ? <></> : null}
                  <Col
                    xl={{span: 3}}
                    md={{span: 3}}
                    sm={{span: 3}}
                    xs={{span: 3}}
                  >
                    <Typography.Title level={5}>{t("Chương", "Chương")}</Typography.Title>
                    <Form.Item name="sectionId">
                      <FormItemDropdown
                        placeholder={t("Chọn chương", "Chọn chương")}
                        onChange={(option) => setFilterData(option, "sectionId")}
                        options={sectionList}/>
                    </Form.Item>
                  </Col></>
                : <></>}

            {
              tab === '3' ?
                <Col
                  xl={{span: 3}}
                  md={{span: 3}}
                  sm={{span: 3}}
                  xs={{span: 3}}
                >
                  <Typography.Title level={5}>{t("Bài giảng", "Bài giảng")}</Typography.Title>
                  <Form.Item name="sequenceId">
                    <FormItemDropdown
                      placeholder={t("Chọn bài giảng", "Chọn bài giảng")}
                      onChange={(option) => setFilterData(option, "sequenceId")}
                      options={sequenceList}
                    />
                  </Form.Item>
                </Col>
                : null
            }
            {
              tab !== '6' ?
                <>
                  <Col
                    xl={{span: 3}}
                    md={{span: 3}}
                    sm={{span: 3}}
                    xs={{span: 3}}
                  >
                    <Typography.Title level={5}>{t("Trạng thái", "Trạng thái")}</Typography.Title>
                    <Form.Item name="availableStatus">
                      <FormItemDropdown
                        placeholder={t("Chọn trạng thái", "Chọn trạng thái")}
                        onChange={(option) => setFilterData(option, "availableStatus")}
                        options={tab === '6' ? statusListQuiz : statusList}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xl={{span: 4}}
                    md={{span: 5}}
                    sm={{span: 5}}
                    xs={{span: 24}}
                  >
                    <Typography.Title level={5}>{t("Ngày xuất bản", "Ngày xuất bản")}</Typography.Title>
                    <Form.Item name="planApprovalDate">
                      <RangePicker
                        placeholder={[t("Ngày bắt đầu", "Ngày bắt đầu"), t("Ngày kết thúc", "Ngày kết thúc")]}
                        format="DD-MM-YYYY"
                        value={filterData.planCreationDate}
                        onChange={(_value, dateString: any) =>
                          setFilterData(dateString, "planApprovalDate")
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xl={{span: 4}}
                    md={{span: 5}}
                    sm={{span: 5}}
                    xs={{span: 24}}
                  >
                    <Typography.Title level={5}>{t("Ngày bắt đầu", "Ngày bắt đầu")}</Typography.Title>
                    <Form.Item name="planCreationDate">
                      <RangePicker
                        placeholder={[t("Ngày bắt đầu", "Ngày bắt đầu"), t("Ngày kết thúc", "Ngày kết thúc")]}
                        format="DD-MM-YYYY"
                        value={filterData.planApprovalDate}
                        onChange={(_value, dateString: any) =>
                          setFilterData(dateString, "planCreationDate")
                        }
                      />
                    </Form.Item>
                  </Col>
                </> : null
            }
            {
              tab === '6' ? (
                <>
                  <Col
                    xl={{span: 3}}
                    md={{span: 3}}
                    sm={{span: 3}}
                    xs={{span: 3}}
                  >
                    <Typography.Title level={5}>{t("Đánh giá", "Đánh giá")}</Typography.Title>
                    <Form.Item name="unitIds">
                      <FormItemDropdown
                        placeholder={t("Chọn đánh giá", "Chọn đánh giá")}
                        modeDropdown={"multiple"}
                        onChange={(option) => setFilterData(option, "unitIds")}
                        options={tab === '6' ? dataOptions.optionUnitName : []}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xl={{span: 4}}
                    md={{span: 5}}
                    sm={{span: 5}}
                    xs={{span: 24}}
                  >
                    <Typography.Title level={5}>{t("Hiển thị", "Hiển thị")}</Typography.Title>
                    <Form.Item name="isShow">
                      <FormItemDropdown
                        placeholder={t("Chọn trạng thái", "Chọn trạng thái")}
                        onChange={(option) => setFilterData(option, "isShow")}
                        options={optionShow}
                      />
                    </Form.Item>
                  </Col>
                </>
              ) : null
            }
            <Col
              xl={{span: 3}}
              md={{span: 9}}
              sm={{span: 9}}
              xs={{span: 24}}
              className="flex align-end"
            >
              <div className="group-btn--filter">
                <Button
                  className="btn btn-primary filter-btn"
                  htmlType="submit"
                  onClick={() => form.submit()}
                >
                  <FilterOutlined/>
                  <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                </Button>
                <Button
                  className="btn btn-outlined clear-filter-btn"
                  onClick={clearFilter}
                >
                  <DeleteOutlined/>
                  <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;